import type { ComponentSchema } from "../../../../../schema-types"
import { SUPPORTED_PAGES, LINK_ITEM_SCHEMA } from '../../_builder-constants'

export const schema: ComponentSchema = {
  type: "footer",
  label: "Footer",
  description: "Site-wide footer: product lists, newsletter and social links, a row of links, payment badges and the copyright.",
  supportedPages: [...SUPPORTED_PAGES],
  variants: [
    {
      id: "v1",
      label: "Product lists",
      fields: [
        {
          key: "productLists",
          label: "Product lists",
          type: "array",
          help: "Up to three short lists of products across the top of the footer, five each.",
          itemSchema: [
            { key: "title", label: "Heading", type: "string" },
            { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 5 } },
          ],
          default: [
            { title: "New in", source: { source: "new", limit: 5 } },
            { title: "Top rated", source: { source: "top_rated", limit: 5 } },
            { title: "On sale", source: { source: "on_sale", limit: 5 } },
          ],
        },
      ],
    },
    { id: "v2", label: "Compact" },
  ],
  commonFields: [
    { key: "logo", label: "Footer Logo", type: "image" },
    { key: "title", label: "Brand Name", type: "string", default: "Juta" },
    {
      key: "description",
      label: "Brand Description",
      type: "text",
      default: "Your destination for premium fashion and lifestyle products. Curated styles for the modern wardrobe.",
    },
    {
      key: "columns",
      label: "Link Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: LINK_ITEM_SCHEMA },
      ],
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" },
          ],
        },
        { key: "href", label: "Link", type: "string" },
      ],
    },
    { key: "contactAddress", label: "Address", type: "string" },
    { key: "contactPhone", label: "Phone", type: "string" },
    { key: "contactEmail", label: "Email", type: "string" },
    {
      key: "newsletterAction",
      label: "Newsletter form URL",
      type: "string",
      placeholder: "https://…",
      help: "Where the email sign-up is sent (your mailing-list provider's form). The sign-up only shows when this is set.",
    },
    {
      key: "note",
      label: "Bottom bar message",
      type: "string",
      placeholder: "Packed with care and delivered to your door.",
      help: "One line above the copyright.",
    },
    { key: "copyright", label: "Copyright Text", type: "string", default: "© 2025 Juta. All rights reserved." },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Visa", value: "visa" },
            { label: "Mastercard", value: "mastercard" },
            { label: "Amex", value: "amex" },
            { label: "Stripe", value: "stripe" },
            { label: "PayPal", value: "paypal" },
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" },
          ],
        },
        { key: "icon", label: "Icon URL (optional)", type: "string" },
      ],
    },
  ],
}
